import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <span className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg font-heading font-bold text-lg">
            911
          </span>
          <span className="font-heading font-bold text-lg text-foreground-900 hidden sm:block">
            黑料网
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`px-3 py-2 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === `/category/${cat.slug}`
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
              }`}
            >
              {cat.name}
            </Link>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/about"
            className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap"
          >
            关于我们
          </Link>
          <button className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 hover:bg-background-200 transition-colors cursor-pointer">
            <i className="ri-search-line text-foreground-600"></i>
          </button>
        </div>

        <button
          className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 hover:bg-background-200 transition-colors cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          <i className={`text-foreground-700 text-lg ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-3 flex flex-col gap-1">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`px-3 py-2.5 rounded-md text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === `/category/${cat.slug}`
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className="px-3 py-2.5 rounded-md text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors whitespace-nowrap"
          >
            关于我们
          </Link>
        </div>
      )}
    </header>
  );
}